import React from 'react';
import { Form, Button, Icon } from '@openedx/paragon';
import { RiSearch2Line, RiFilter3Line } from '@remixicon/react';
import { useIntl } from '@edx/frontend-platform/i18n';

import messages from '../messages';

const WishlistHeader = ({ searchValue, onSearchChange }) => {
  const { formatMessage } = useIntl();
  return (
    <section className="wishlist-page__header">
      <h2 className="wishlist-page__title">{formatMessage(messages.heading)}</h2>

      <div className="wishlist-page__search-row">
        <Form.Control
          size="lg"
          placeholder={formatMessage(messages.searchPlaceholder)}
          value={searchValue}
          onChange={(e) => onSearchChange(e.target.value)}
          leadingElement={<Icon src={RiSearch2Line} />}
        />
        <Button
          variant="outline-secondary"
          size="lg"
          iconBefore={RiFilter3Line}
        >
          {formatMessage(messages.filterButton)}
        </Button>
      </div>
    </section>
  );
};

export default WishlistHeader;
